module.exports = __webpack_public_path__ + "static/img/7.228824f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/sp/7.png
// module id = jvnr
// module chunks = 0